import React from 'react';

import $ from 'jquery';

import Row from '../ui/Row';
import DelimHrHidden from '../ui/DelimHrHidden';
import PanelActivity from './panels/PanelActivity';
import PanelOptions from './panels/PanelOptions';
import PanelLog from './panels/PanelLog';
import PanelAccount from './panels/PanelAccount';
import PanelPrice from './panels/PanelPrice';


export default class UnderHeader extends React.Component {

constructor(props) {
  super(props);
  this.state = {
    data : [],
    value: 'coconut',
    toFollow: true,
    toUnfollow: false,
    };


    this.handleSubmit = this.handleSubmit.bind(this);
    //remove?
    this.handleStartStopActivityClicked = this.handleStartStopActivityClicked.bind(this);

}

handleSubmit(event) {
  event.preventDefault();
}

componentWillMount() {
  document.body.classList.add('under-head-page');
}

componentWillUnmount(){
  document.body.classList.remove('under-head-page');
}

componentDidMount()
 {
  // this.getFunction();

   //adjust input placeholders to fit
   $("input[placeholder]").each(function () {
        $(this).attr('size', $(this).attr('placeholder').length);
    });
   //<-

 }

  handleStartStopActivityClicked()
  {

    this.setState({showErrors: true});

    //if(errors)
    if($.isEmptyObject(this.state.validationErrors) === false) return null;
  }


  startActivity()
  {

  }

  activityButtonTitle()
  {
    return this.state.activityOn?'Stop':'Start';
  }

  render() {

      return (
        <form className='under-head' onSubmit={this.handleSubmit}>
          <PanelAccount/>
                 
          <PanelActivity/>
          
          <PanelOptions/>
          
          <PanelLog/>

          <PanelPrice/>
        </form>
      );
    }
}
